import * as React from 'react';
import BooksSidebar from './BooksSidebar/BooksSidebar';
import './BookCalendar.css';
import BookCard from './BookCard/BookCard';
import { CardType } from '../../types/LibraryCard';
import MediaQuery from 'react-responsive';
import { MOBILE_MAX_WIDTH } from '../../utils';
import MobileCalendar from './MobileCalendar/MobileCalendar';
import BookCardWrapper from './BookCardWrapper/BookCardWrapper';
import { CardsManagerCallbacks } from '../CardsManager/CardsManager';
import LinearProgress from '@material-ui/core/LinearProgress';

interface OwnProps {
	callbacks: CardsManagerCallbacks;
	setCardId: (cardId: number) => void;
	cardId?: string;
	defaultSection?: string;
	loading?: boolean;
}

export const CallbacksContext = React.createContext<CardsManagerCallbacks>(null);

const BookCalendar: React.FunctionComponent<OwnProps> = props => {
	const cardId = props.cardId ? parseInt(props.cardId) : -1;

	const alreadyRead = props.callbacks.cards.filter(cards => cards.cardType === CardType.AlreadyRead);
	const wantRead = props.callbacks.cards.filter(cards => cards.cardType === CardType.WantRead);
	const readNow = props.callbacks.cards.filter(cards => cards.cardType === CardType.ReadNow);

	return <div className="book-calendar">
		<CallbacksContext.Provider value={props.callbacks}>
			<MediaQuery minWidth={MOBILE_MAX_WIDTH}>
				<div className="book-calendar__sidebar">
					<BooksSidebar
						alreadyRead={alreadyRead}
						wantRead={wantRead}
						readNow={readNow}
						onCardSelect={bookId => props.setCardId(bookId)}
						selectedBookId={cardId}
					/>
				</div>

				<div className="book-calendar__main">
					{props.loading && <LinearProgress/>}

					{props.cardId && <BookCardWrapper libraryCard={props.callbacks.calendar[cardId]} />}
					
					{!props.cardId && <BookCard card={null}/>}
				</div>
			</MediaQuery>

			<MediaQuery maxWidth={MOBILE_MAX_WIDTH}>
				<MobileCalendar
					wantRead={wantRead}
					alreadyRead={alreadyRead}
					readNow={readNow}
					books={props.callbacks.calendar}
					cardId={cardId}
					setCard={props.setCardId}
					defaultSection={props.defaultSection}
					loading={props.loading}
				/>
			</MediaQuery>
		</CallbacksContext.Provider>
	</div>;
};

export default BookCalendar;
